import JSONAPIClient from '../JSONAPIClient'

JSONAPIClient.define(
  'docutech_sso_token',
  { access_token: '' }
)
